import { BlocksIconControlCenter } from 'blocks-nextjs/blocks-web-components/components/icon/icons/control-center';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconControlCenter = createComponent({
  react: React,
  tagName: 'cat-icon-control-center',
  elementClass: BlocksIconControlCenter
});
